import React from 'react';

export default function NotFound() {
  return (
    <div className='w-full h-screen flex items-center justify-center text-2xl'>
      찾지 못한 페이지입니다. 😥
    </div>
  );
}
